import { generateUrlParams } from '../../utils/generateUrlParams';
const baseUrl = "CourseRegistration";

export const getBorrowedCourseRegsToToggleUrl = (filter) =>
    `${baseUrl}/open-or-close-student-course-borrowing?${generateUrlParams(filter)}`;

export const toggleBorrowedCourseRegUrl = (filter) =>
    `${baseUrl}/open-or-close-student-course-borrowing?${generateUrlParams(filter)}`;